import { USER_FORM } from './form-portaluser-type';
import useAuth from '../../../hooks/auth-hooks';
import { getAccessPrevilages, getAndFormatAccessList } from './form-user-helpers' ;
import { checkForSelectValue } from '../form-helpers';
import { showToast } from '../../toasts';

import { wpUpdateUserIndividual, awsUpdateUserIndividual } from '../../../routes/update-user-individual';

/**
 * Updates a portal user by calling the Wordpress and AWS api route functions.
 * 
 * @returns void
 */
const UpdatePortalUser = async () => {
  if ( !USER_FORM.userUpdate ) return;
  const { userUpdate, userID, userStatus, userRole, userName, userFirstName, userLastName, userEmail, userSubmit } = USER_FORM;

  const validateForm = (custPartArray: string) => {
    USER_FORM.userUpdate.classList.add('was-validated');

    checkForSelectValue(userStatus, 'User Status', 'status');
    checkForSelectValue(userRole, 'User Role', 'role');

    return userUpdate.checkValidity() &&
        userStatus.getAttribute('data-value') != null &&
        userRole.getAttribute('data-value') != null &&
        custPartArray != '';
  }

  const handleUpdate = async (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    const custPartArray = getAndFormatAccessList();

    if ( validateForm(custPartArray) ) {
      userUpdate.classList.remove('was-validated');
      userUpdate.classList.remove('form-control:valid');
      userSubmit.classList.add('aafp_button-loading');

      const wpModelData = {
        updateUserID: userID.value,
        updateUserName: userName.value,
        updateUserFirstName: userFirstName.value,
        updateUserLastName: userLastName.value,
        updateUserEmail: userEmail.value,
        updateUserStatus: String(userStatus.getAttribute('data-value')),
        updateUserRole: String(userRole.getAttribute('data-value'))
      };

      const { accessLevel, accessType } = getAccessPrevilages(userRole.getAttribute('data-value')!);
      const { userId } = useAuth()!;

      const awsModelData = {
        updateWpId: userID.value,
        updateWpName: `${userFirstName.value} ${userLastName.value}`,
        updateAccessLevel: accessLevel,
        updateAccessType: accessType,
        updateIdArray: custPartArray,
        adminId: userId
      }

      try {
        await wpUpdateUserIndividual(wpModelData);
        await awsUpdateUserIndividual(awsModelData);

        showToast('aafp_toast', `${USER_FORM.userFirstName.value} ${USER_FORM.userLastName.value} has been updated`);
        setTimeout(() => {
          location.href = '/portal-users/';
        }, 1500);
      } catch (error) {
        showToast('aafp_toast-alert', 'Error Updated User');
      }
    }
  }

  userUpdate.addEventListener('submit', handleUpdate);
}

export default UpdatePortalUser;